import { actions, withAuth } from '../store';
import { Box } from '../components/common/box';
import { PagePlain } from '../components/page';
import { ResetPasswordForm } from '../components/resetPassword';

const ResetPassword = ({ messages }) => (
  <PagePlain title={messages.authResetPassword}>
    <ResetPasswordForm />
  </PagePlain>
);

ResetPassword.getInitialProps = async ({ reduxStore, query }) => {
  reduxStore.dispatch(actions.setInitialPageState({
    passwordExpired: query.expired || null
  }));
  return {};
};

export default withAuth(['PUBLIC'])(ResetPassword);
